// extracted by mini-css-extract-plugin
export var title = "title-module--title--WKni5";
export var shadow = "title-module--shadow--bpLwA";
export var center = "title-module--center--0YGW5";
export var overflowHidden = "title-module--overflowHidden--hKGx3";
export var lg = "title-module--lg--vuatJ";
export var md = "title-module--md--Gffey";
export var sm = "title-module--sm--aQ62j";